import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Route,
    Router,
    UrlSegment,
} from '@angular/router';
import {
    AuthenticatorService,
    Permission,
    UserPage,
} from '../Services/authenticator.service';
import { PingService } from '../Services/ping.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationGuard {
    constructor(
        private router: Router,
        private auth: AuthenticatorService,
        private pingService: PingService,
        private snackBar: MatSnackBar,
        private ngxService: NgxUiLoaderService
    ) {}

    async canLoad(route: ActivatedRouteSnapshot): Promise<boolean> {
        const backend = await this.pingService.makePing();

        if (backend) {
            const logged: Permission = await this.auth.isLogged();
            if (logged.access) {
                if (logged.enCierre) {
                    const pageCierre: string =
                        '/' +
                        UserPage.ServiciosEscolares +
                        '/mantenimiento/cierre-de-semestre';

                    if (route?.data?.paginaCierre) {
                        return true;
                    } else {
                        this.router.navigate([pageCierre]);
                        return false;
                    }
                } else if (logged.sinCorreoActivo) {
                    const pageEvaluacion: string =
                        '/' + UserPage.Alumno + '/inicio';

                    if (route?.data?.paginaInicio) {
                        return true;
                    } else {
                        this.router.navigate([pageEvaluacion]);
                        return false;
                    }
                } else if (logged.enEvaluacion) {
                    const pageEvaluacion: string =
                        '/' + UserPage.Alumno + '/evaluacion-docente';

                    if (route?.data?.paginaEvaluacion) {
                        return true;
                    } else {
                        this.router.navigate([pageEvaluacion]);
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                this.router.navigate(['/login']);
                return false;
            }
        } else {
            return false;
        }
    }

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        this.ngxService.start();
        const backend = await this.pingService.makePing();

        if (location.hostname != 'localhost') {
            const url: string = route.pathFromRoot
                .map((pfr) => pfr.url)
                .join('/')
                .replaceAll('//', '/');
            const queryParams: string = JSON.stringify(route.queryParams)
                .replaceAll(',', '&')
                .replaceAll(':', '=')
                .replaceAll('"', '')
                .replaceAll('{', '?')
                .replaceAll('}', '');
            const path = url + (queryParams.length > 1 ? queryParams : '');
            await this.pingService.savePath(path);
        }

        if (backend) {
            // const token: string | undefined =
            //     await this.pingService.recaptchaV3('guardAction');
            // const recaptcha = token
            //     ? await this.pingService.validateRecapchaV3(token)
            //     : true;

            const recaptcha = true;

            if (recaptcha) {
                const logged: Permission = await this.auth.isLogged();
                this.ngxService.stop();

                if (logged.access) {
                    if (logged.enCierre) {
                        const pageCierre: string =
                            '/' +
                            UserPage.ServiciosEscolares +
                            '/mantenimiento/cierre-de-semestre';

                        if (route?.data?.paginaCierre) {
                            return true;
                        } else {
                            this.snackBar.open('En Cierre de Semestre', '🤖', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                panelClass: ['snack-error-message'],
                            });
                            this.router.navigate([pageCierre]);
                            return false;
                        }
                    } else if (logged.sinCorreoActivo) {
                        const pageEvaluacion: string =
                            '/' + UserPage.Alumno + '/inicio';

                        if (route?.data?.paginaInicio) {
                            return true;
                        } else {
                            this.snackBar.open(
                                'Valida que ya Activaste tu Correo Institucional',
                                '🤖',
                                {
                                    duration: 3000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'right',
                                    panelClass: ['snack-error-message'],
                                }
                            );
                            this.router.navigate([pageEvaluacion]);
                            return false;
                        }
                    } else if (logged.enEvaluacion) {
                        const pageEvaluacion: string =
                            '/' + UserPage.Alumno + '/evaluacion-docente';

                        if (route?.data?.paginaEvaluacion) {
                            return true;
                        } else {
                            this.snackBar.open(
                                ' Debe contestar su evaluación',
                                '🤖',
                                {
                                    duration: 3000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'right',
                                    panelClass: ['snack'],
                                }
                            );
                            this.router.navigate([pageEvaluacion]);
                            return false;
                        }
                    } else {
                        return true;
                    }
                } else {
                    this.router.navigate(['/login']);
                    return false;
                }
            } else {
                this.ngxService.stop();
                this.snackBar.open(
                    'Tráfico inusual procedente de tu red de computadoras',
                    '🤖',
                    {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        panelClass: ['snack-error-message'],
                    }
                );
                return false;
            }
        } else {
            this.snackBar.open(
                'El servidor no puede atender temporalmente su solicitud debido a un tiempo de inactividad por mantenimiento o problemas de capacidad. Por favor, inténtelo de nuevo más tarde.',
                '🤖',
                {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    panelClass: ['snack-error-message'],
                }
            );
            this.ngxService.stop();
            return false;
        }
    }
}
